import React from 'react';

import { Box, Typography } from '@mui/material';
import CodeMirrorPreview from '@wp-react/components/CodeMirror/CodeMirrorPreview';

type Props = {
  title: string;
  value: string | Record<string, unknown> | null | undefined;
};

export default function PreviewBox({ title, value }: Props) {
  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <CodeMirrorPreview
        language="JSON"
        value={getFormattedJson(value)}
        sx={{
          bgcolor: 'cadet.200',
          '.cm-gutters': {
            bgcolor: 'cadet.200',
            borderRightColor: 'transparent',
          },
        }}
      />
    </Box>
  );
}

function getFormattedJson(str: string | Record<string, unknown> | null | undefined) {
  if (str === null || str === undefined) {
    return '';
  }
  if (typeof str === 'string') {
    try {
      return JSON.stringify(JSON.parse(str), null, '  ');
    } catch (e) {
      return str;
    }
  }
  return JSON.stringify(str, null, '  ');
}
